import React from 'react';
import { Button, Icon, notification } from '@ss/mtd-react';
import { Upload } from '@block/plug';
import { doAction, getServiceType } from '../../utils';
import { Header } from '../../components';
import Url from './url';
import './index.scss';

// const signUrl = 'http://sign.it.test.sankuai.com/';
// const signUrl = 'https://sign.meituan.com/';
// const signUrl = 'http://localhost:3312/';

const tenantUid = window.location.hash.split('/')[2];

const { helper } = Upload;
const fileType = 22; // 电子签

interface Props {
  count: number;
}

interface State {
  visible: boolean;
  fileList: any[];
  sign: any;
}
class Sign extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      visible: null,
      fileList: [],
      sign: null,
    };
  }

  async componentDidMount() {
    await getServiceType();
    // if (!window.hasSign && window.signType !== 0) {
    //   window.location.href = `/#/candidate/${tenantUid}/login`;
    // }
    if (window.signType === 1) {
      // 电子签
      this.setState({
        visible: true,
      });
      window.addEventListener(
        'message',
        (event) => {
          const { sign } = event.data;
          if (sign) {
            this.setState({ sign });
          }
        },
        false,
      );
    }
    if (window.signType === 2) {
      const { pageList } = await doAction(`${Url.getFileList}/${fileType}`);
      this.setState({ fileList: pageList });
    }
    // if (!window.signType || window.signType === 0) {
    //   window.location.href = `/#/candidate/${tenantUid}/login`;
    // }
  }

  validateFileType = (file, accepted) => {
    const fileExt = (/^.*\.(.*)$/.exec(file.name) || ['', ''])[1].toLowerCase();
    const valid = accepted.includes(fileExt);
    if (!valid) {
      notification.error({
        message: `不支持上传非 ${accepted.join('、')}格式文件，请重新上传`,
      });
    }
    return valid;
  };

  validateFileSize = (file, size) => {
    const valid = file.size / 1024 <= size * 1024;
    if (!valid) {
      notification.error({
        message: `文件大小超过${size}M,请重新上传`,
      });
    }
    return valid;
  };

  handleUpload = (file) => {
    let { count } = this.props;
    const type = ['png', 'jpeg', 'jpg', 'pdf', 'doc', 'docx'];
    count = count || 4; // 最多4个
    if (!this.validateFileType(file, type) || !this.validateFileSize(file, 20)) {
      return false;
    }

    helper.upload(`${Url.upload}/${fileType}`, file, {
      onSuccess: (res) => {
        let { fileList } = this.state;
        if (fileList.length >= count) {
          fileList = fileList.splice(0, fileList.length - 1);
        }
        fileList.push(res);
        this.setState({
          fileList,
        });
        notification.success({
          message: '上传成功',
        });
      },
      onError: (err) => {
        notification.error({
          message: err.message || '上传失败',
        });
      },
    });
    return null;
  };

  // 文件删除
  handleRemove = async (fileId) => {
    await doAction(Url.delete, {
      fileId,
    });
    const { fileList } = this.state;
    this.setState({ fileList: fileList.filter((item) => item.fileId !== fileId) });
  };

  // 文件预览
  handlePreview = async (fileId, fileName) => {
    window.open(`/api/candidate/${window.checkTypeValue}/${tenantUid}/attachment/view/${fileId}/${fileName}/do`);
  };

  // 文件下载
  handleDownload = async (fileId) => {
    window.open(`${Url.download}/${fileId}`);
  };

  // 点击填写候选人详细信息
  handleSubmit = async () => {
    const { fileList, sign } = this.state;
    if ((fileList && fileList.length > 0) || sign) {
      await doAction(Url.done);
      window.location.hash = `#/candidate/${tenantUid}/`;
    }
  };

  handleDownloadTemplate = async () => {
    window.open('/api/candidate/background/1/attachment/getAuthorizationFile');
  };

  // 电子版电子签
  renderIframe = () => {
    const { sign } = this.state;
    const href = window.location.protocol;
    const signUrl = href !== 'http:' ? 'https://sign.meituan.com/' : 'http://sign.it.test.sankuai.com/';
    return (
      <>
        <div className="sign__content">
          <iframe
            src={signUrl}
            className="sign__iframe"
            scrolling="auto"
            title="电子签"
            height="100%"
            width="100%"
            id="ruzhi_iframe"
          />
        </div>
        <Button type="primary" className="sign__btn" onClick={this.handleSubmit} disabled={!sign}>
          继续填写信息
        </Button>
      </>
    );
  };

  // 上传纸质电子签
  // <Icon type="download-o" onClick={() => this.handleDownload(fileId)} />
  renderSign = () => {
    const { fileList } = this.state;
    return (
      <div className="manual">
        <div className="manual__title">填写个人信息前，请先签署背调授权书</div>
        <div className="manual__wrapper">
          <div className="manual__content">
            <div className="manual__item manual__subtitle">背调授权书</div>
            <div className="manual__item">
              <span className="manual__step">1</span>
              <div className="manual__name">下载授权书</div>
              <div className="manual__file" onClick={this.handleDownloadTemplate}>
                <Icon type="file" />
                <div className="manual__filename">背调授权书.doc</div>
                <Icon type="download-o" className="manual__download" />
              </div>
            </div>
            <div className="manual__item">
              <span className="manual__step">2</span>
              <div className="manual__name">打印并手动签署授权书</div>
            </div>
            <div className="manual__item">
              <span className="manual__step">3</span>
              <div className="manual__name" style={{ marginBottom: '8px' }}>
                上传已签署授权书
              </div>
              {(!fileList || (fileList && fileList.length < 4)) && (
                <Upload className="manual__upload" draggable multiple onUpload={this.handleUpload}>
                  <Icon type="export-o" />
                  <div>点击或将文件拖拽到这里上传</div>
                </Upload>
              )}
              {fileList.map((item) => {
                const { fileName, fileId } = item;
                return (
                  <div className="manual__file">
                    <div className="manual__file-wrapper">
                      <span className="manual__file-content">
                        <Icon type="file-o" />
                        <span className="manual__fileItem">{fileName}</span>
                      </span>
                      <span className="manual__right">
                        <Icon type="download-o" onClick={() => this.handlePreview(fileId, fileName)} />
                        <Icon type="delete-o" onClick={() => this.handleRemove(fileId)} />
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="manual__item manual__submit">
              <Button
                type="primary"
                onClick={this.handleSubmit}
                disabled={!fileList || (fileList && fileList.length === 0)}
              >
                完成
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { visible } = this.state;
    return (
      <div className="sign">
        <Header />
        {visible && this.renderIframe()}
        {!visible && this.renderSign()}
      </div>
    );
  }
}

export default Sign;
